import React from "react";
import Markdoc from "@markdoc/markdoc";
import { markdocConfig } from "./config";
import {
  Heading,
  Paragraph,
  Strong,
  Emphasis,
  Strikethrough,
  InlineCode,
  CodeBlock,
  MarkdocLink,
  MarkdocImage,
  Blockquote,
  HorizontalRule,
  List,
  ListItem,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableHeader,
  TableCell,
  Callout,
  Tabs,
  Tab,
  MarkdocBadge,
} from "./components";
import {
  SectionHeading,
  TocItem,
  Step,
  Card,
  Endpoint,
  ScoreRange,
} from "./doc-components";

const components = {
  Heading,
  Paragraph,
  Strong,
  Emphasis,
  Strikethrough,
  InlineCode,
  CodeBlock,
  MarkdocLink,
  MarkdocImage,
  Blockquote,
  HorizontalRule,
  List,
  ListItem,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableHeader,
  TableCell,
  Callout,
  Tabs,
  Tab,
  MarkdocBadge,
  SectionHeading,
  TocItem,
  Step,
  Card,
  Endpoint,
  ScoreRange,
};

interface MarkdocRendererProps {
  content: string;
  className?: string;
}

export function MarkdocRenderer({ content, className }: MarkdocRendererProps) {
  const ast = Markdoc.parse(content);
  const transformed = Markdoc.transform(ast, markdocConfig);
  const rendered = Markdoc.renderers.react(transformed, React, { components });

  return <div className={className}>{rendered}</div>;
}
